import { FRFloor } from 'src/_models/FRFloor';
import { MpSdk } from 'src/types';
import { Floor } from './floor';
import { Sweep } from './sweep';
import { Tag, TagEventsType } from './tag';
import { Tour } from './tour';
import { NodeFactory } from './scene';
import { SceneSettings } from 'src/_models';
import { ListenerFn } from 'eventemitter3';

export { TagEventsType };

export type SDKConfig = {
  appAws: string;
  appDomain: string;
  applicationKey: string;
  version: string;
  isMobile?: boolean;
  adminPanelAccess?: boolean;
  logoUrl: string | null;
  disableConsole?: boolean;
  settings?: SceneSettings;
  frFloors?: FRFloor[];
  auth?: string;
  matterId?: string;
  rtl?: boolean;
};

export enum TourLoaderEventsType {
  LOADING = 'loading',
  STARTING = 'starting',
  PLAYING = 'playing',
}

export type TourLoaderInstance = {
  sweep: Sweep;
  tag: Tag;
  floor: Floor;
  tour: Tour;
  scene: NodeFactory;
  showcase: MpSdk;
  on: (type: TourLoaderEventsType, callback: ListenerFn) => void;
  addListener: (type: TourLoaderEventsType, callback: ListenerFn) => void;
  removeListener: (type: TourLoaderEventsType, callback?: ListenerFn) => void;
};

export type TSceneComponent = MpSdk.Scene.IComponent;
